import React, { ReactElement } from "react";

import { ProjectTask } from ".";

interface IProps {
	task: ProjectTask;
	fontSize?: number;
	padding?: number;
	paddingHorizontal?: number;
	paddingVertical?: number;
}

export const ProjectTaskLabelsList = (props: IProps): ReactElement => {
	const labelEls = props.task.labels.map((label, index) => {
		return (
			<div
				key={index}
				style={{
					backgroundColor: label.color || "#000",
					color: "#fff",
					display: "inline-block",
					borderRadius: 4,
					marginRight: 4,
					marginTop: 4,
					paddingLeft: props.paddingHorizontal || 10,
					paddingRight: props.paddingHorizontal || 10,
					paddingTop: props.paddingVertical || 3,
					paddingBottom: props.paddingVertical || 3,
					fontSize: props.fontSize || 11,
				}}
			>
				{label.name}
			</div>
		);
	});

	return <div style={{ marginBottom: 10 }}>{labelEls}</div>;
};
